module.exports = __webpack_public_path__ + "assets/img/logo2_600_600.6ad69550.png";